import styled from "@emotion/styled"
import { TextField } from "@mui/material"

export const Wrapper = styled(TextField)`
  .MuiFormLabel-root {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    padding-left: 1rem;
  }

  .MuiOutlinedInput-input {
    color: rgba(255, 255, 255, 0.4);
  }

  .MuiInputLabel-outlined,
  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(255, 255, 255, 0.4) !important;
  }

  /*.MuiOutlinedInput-root {
    background-color: #323a46;
  }*/

  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  width: 100%;
  .MuiInputLabel-root {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .MuiFormHelperText-root {
    margin-right: auto;
  }
`
